import { Loader } from '@recruit-robin/robin-theme/web-components';
import { routes } from 'config';
import { Navigate, useLocation } from 'react-router-dom';
import { ConfigContext } from 'shared/legacy/contexts/ConfigContext/ConfigContext';
import { useAuth, useFeatureToggles } from 'shared/legacy/hooks';
import { useContextSelector } from 'use-context-selector';
import { RequireAuthProps } from './types';

const RequireAuth = ({ children, shouldAllow: shouldAllowHandler }: RequireAuthProps) => {
  const auth = useAuth();
  const isIframe = useContextSelector(ConfigContext, (state) => state.isIframe);

  const featureToggles = useFeatureToggles();
  const location = useLocation();
  const shouldAllow = shouldAllowHandler?.({ auth, featureToggles }) ?? auth.isLoggedIn;
  const { isAllowed, redirectTo = isIframe ? routes.search() : routes.home } =
    typeof shouldAllow === 'boolean' ? { isAllowed: shouldAllow } : shouldAllow;

  if (auth.isLoading || (auth.isLoggedIn && featureToggles.isLoading)) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100%',
        }}>
        <Loader size={48} />
      </div>
    );
  }

  if (!auth.isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RequireAuth;
